import request from '../../utils/request';

const DEMO_ADMIN_EMAIL =
  process.env.REACT_APP_DEMO_ADMIN_EMAIL || 'demo@chileconverge.cl';

function login({ email, password, recaptchaToken, recaptchaAction }) {
  const normalizedEmail = email ? email.trim().toLowerCase() : '';

  return request({
    url: 'user/auth',
    method: 'POST',
    data: {
      email,
      password,
      gRecaptchaResponse: recaptchaToken, // Backend espera este nombre
      recaptchaAction,
      isDemo: normalizedEmail === DEMO_ADMIN_EMAIL.toLowerCase(),
      channel: 'WEB_ADMIN',
    },
  });
}

function getRoles() {
  return request({
    url: 'role/list',
    method: 'GET',
    private: true,
  });
}

function getSettings() {
  return request({
    url: 'client/info',
    method: 'GET',
    private: true,
  });
}

const AuthAPI = {
  login,
  getRoles,
  getSettings,
};

export default AuthAPI;
